import React from 'react';

import { Input as SemanticInput } from 'semantic-ui-react';

const Input = ({ field, ...props }) => (
  <SemanticInput {...field} {...props} />
);

export default Input;
